import type { Enums, Nullable } from "../types";
import { COLORS } from "./colors";

/**
 * Converts a string to a color by hashing the string and using the hash to index into a list of colors.
 * @param {string} input - The input string to convert to a color.
 * @returns {string} - A color string in hex format.
 * @param input
 * @returns
 */
export function getColorByString(input: Nullable<string>): Enums<"color"> {
	if (!input) return "gray";
	const colors = COLORS;
	const hash = Array.from(input).reduce((acc, char) => {
		return acc + char.charCodeAt(0);
	}, 0);
	const index = hash % colors.length;
	return colors[index] as Enums<"color">;
}
